import { z } from 'zod';

// ─────────────────────────────────────────────────────────────────
// Fonts response shape (what the API returns)
// ─────────────────────────────────────────────────────────────────
export const FontResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  createdAt: z.string(),
});

export type FontResponse = z.infer<typeof FontResponseSchema>;
